import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InfoIcon from '../../assets/icons/InfoIcon';
import { VehicleDetails } from '../../types';
import { COLORS } from '../../styles/variables';
import { vehicleContext } from '../VehicleProvider';
import PriceLabel from '../PriceLabel';
import {
  PriceBlockContainer,
  PriceCopy,
  PriceContainer,
  VehiclePrice,
  InfoIconWrapper,
} from './StickyNavbar.styles';

interface PriceBolcComponentProps {
  onModalOpen: () => void;
}

const PriceBlock: React.FC<PriceBolcComponentProps> = ({ onModalOpen }) => {
  const { t } = useTranslation();

  const { vehicle } = useContext(vehicleContext);
  const { modelPrice, modelPriceRetail, market, isAvailableNow, vehicleType } =
    (vehicle as VehicleDetails) ?? {};

  const isMarketUSA = market.includes('us');

  const correctPrice = useMemo(() => {
    if (isMarketUSA && !isAvailableNow && vehicleType === 'new') return 'Available soon';
    if (isMarketUSA) return `$${modelPrice}`;
    return modelPriceRetail;
  }, [isAvailableNow, isMarketUSA, modelPrice, modelPriceRetail, vehicleType]);

  return (
    <>
      <PriceBlockContainer>
        <>
          <PriceCopy>
            <PriceLabel />
          </PriceCopy>
          <PriceContainer>
            <VehiclePrice data-testid="model-price">{correctPrice}</VehiclePrice>
            <InfoIconWrapper
              onClick={onModalOpen}
              aria-label={t('vehiclePricingBar.ariaLabel.legalInformation')}
              data-testid="price-legal-popover-trigger"
            >
              <InfoIcon color={COLORS.grey10} size={22} />
            </InfoIconWrapper>
          </PriceContainer>
        </>
      </PriceBlockContainer>
    </>
  );
};

export default PriceBlock;
